export default __webpack_public_path__ + "static/media/infocard2.26679835.png";